<div class="application-view-main-container">
    <div class="application-view-title">WYBIERZ KAMPANIĘ PROMOCYJNĄ</div>
    <div class="buttons-container">
        <button type="button" class="btn btn-third-custom btn-third-option air" (click)="switchModule('airConditioners')">KLIMATYZACJA</button>
        <button type="button" class="btn btn-third-custom btn-third-option pump" (click)="switchModule('pumps')">POMPY CIEPŁA</button>
    </div>
</div>